import './BrandedWelcome.css';

interface BrandedWelcomeProps {
  orgName: string;
  logoUrl: string | null;
}

/**
 * Branded welcome screen — the first real screen that validates the theming pipeline.
 *
 * Full viewport dark gradient background using the org's primary color.
 * Large centered org logo with radial glow behind it.
 * Org name in large, elegant typography below.
 */
export default function BrandedWelcome({
  orgName,
  logoUrl,
}: BrandedWelcomeProps) {
  return (
    <div className="branded-welcome">
      {/* Radial gradient glow behind center content */}
      <div className="branded-welcome__glow" />

      {/* Subtle animated gradient overlay */}
      <div className="branded-welcome__gradient-shift" />

      <div className="branded-welcome__content">
        {logoUrl ? (
          <img
            className="branded-welcome__logo"
            src={logoUrl}
            alt={`${orgName} logo`}
            draggable={false}
          />
        ) : (
          <div className="branded-welcome__logo-placeholder">
            {orgName.charAt(0)}
          </div>
        )}

        <h1 className="branded-welcome__name">{orgName}</h1>
      </div>
    </div>
  );
}
